export default "__VITE_ASSET__0VIS$FIu__"